import script from "./ArticleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleForm.vue?vue&type=script&setup=true&lang=js"

import "./ArticleForm.vue?vue&type=style&index=0&id=268a6142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268a6142"]])

export default __exports__